import { HStack, Stack, Icon } from "@chakra-ui/react";
import { IconType } from "@onemind-services-llc/react-icons-ng";
import { FaUserAlt } from "@onemind-services-llc/react-icons-ng/fa";
import { Text } from "@/elements";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";

type ReviewCardProps = {
  text: string;
  name: string;
  icon?: IconType;
  designation: string;
};

const ReviewCard = (props: ReviewCardProps) => {
  const { text, name, icon = FaUserAlt, designation } = props;
  const textVariant = useTextVariant();
  return (
    <Stack
      p={6}
      gap={10}
      justifyContent={"space-between"}
      border="1px solid #9ECFFF"
      bgColor={"#F9FAFC"}
      borderRadius={"12px"}
      boxShadow={"lg"}
    >
      <Text variant={"label1"}>{text}</Text>
      <HStack gap={4}>
        <Icon as={icon} w={8} h={8} />
        <Stack gap={1}>
          <Text variant={textVariant} fontWeight={600}>
            {designation}
          </Text>
          <Text variant={textVariant} color={"text.100"}>
            {name}
          </Text>
        </Stack>
      </HStack>
    </Stack>
  );
};

export default ReviewCard;
